const estates = [
        { label: 'Rondônia',            code: 'RO',     cUf: '27' },
        { label: 'Acre',                code: 'AC',     cUf: '11' },
        { label: 'Amazonas',            code: 'AM',     cUf: '13' },
        { label: 'Roraima',             code: 'RR',     cUf: '14' },
        { label: 'Pará',                code: 'PA',     cUf: '15' },
        { label: 'Amapá',               code: 'AP',     cUf: '16' },
        { label: 'Tocantins',           code: 'TO',     cUf: '17' },
        { label: 'Maranhão',            code: 'MA',     cUf: '21' },
        { label: 'Piauí',               code: 'PI',     cUf: '22' },
        { label: 'Ceará',               code: 'CE',     cUf: '23' },
        { label: 'Rio Grande do Norte', code: 'RN',     cUf: '24' },
        { label: 'Paraíba',             code: 'PB',     cUf: '25' },
        { label: 'Pernambuco',          code: 'PE',     cUf: '26' },
        { label: 'Alagoas',             code: 'AL',     cUf: '27' },
        { label: 'Sergipe',             code: 'SE',     cUf: '28' },
        { label: 'Bahia',               code: 'BA',     cUf: '29' },
        { label: 'Minas Gerais',        code: 'MG',     cUf: '31' },
        { label: 'Espírito Santo',      code: 'ES',     cUf: '32' },
        { label: 'Rio de Janeiro',      code: 'RJ',     cUf: '33' },
        { label: 'São Paulo',           code: 'SP',     cUf: '35' },
        { label: 'Paraná',              code: 'PR',     cUf: '41' },
        { label: 'Santa Catarina',      code: 'SC',     cUf: '42' },
        { label: 'Mato Grosso do Sul',  code: 'MS',     cUf: '50' },
        { label: 'Mato Grosso',         code: 'MT',     cUf: '51' },
        { label: 'Goiás',               code: 'GO',     cUf: '52' },
        { label: 'Rio Grande do Sul',   code: 'RS',     cUf: '43' },
        { label: 'Distrito Federal',    code: 'DF',     cUf: '53' }
    ]

export default {
    getEstates () {
        return estates
    },

    getCUFByCode (code) {
        return estates.filter((uf) => uf.code == code)[0].cUf || null
    }
}